import { Divider } from '@mui/material';
import {
  Fragment,
} from 'react';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../language/keys';
import { ContactDetail } from '../ContactDetailsModal';
import ErrorMessage from '../ErrorMessage';
import { BasicEmailRow } from './BasicEmailRow';
import { BasicPhoneRow } from './BasicPhoneRow';

type ContactDetailsProps = {
  disabled?: boolean,
  arrEmails: EmailItem[],
  editEmailArrayHandler?: (item :{
    id: string,
    value: string,
  }) => void,
  handleIsShowAddRowEmail?: () => void,
  handleDeleteEmailRow?: (itemId: string) => void,
  isShowNewRowEmail?: boolean,
  newValueEmail?: string,
  handleEmailChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  handleConfirmClickEmail?: () => void,
  arrPhones: PhoneItem[],
  editPhoneArrayHandler?: (item :{
    id: string,
    value: string,
  }) => void,
  handleDeletePhoneRow?: (itemId: string) => void,
  isShowNewRowPhone?: boolean,
  newValuePhone?: string,
  handlePhoneChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  handleConfirmClickPhone?: () => void,
  formErrors?:ContactDetail,
}

export default function ContactDetails({
  disabled,
  arrEmails,
  editEmailArrayHandler,
  handleDeleteEmailRow,
  arrPhones,
  editPhoneArrayHandler,
  handleDeletePhoneRow,
  formErrors,
}:ContactDetailsProps): JSX.Element {
  const { t: translate } = useTranslation();

  const getMailError = (id: string) => {
    if (formErrors?.emails) {
      return formErrors?.emails.find((email:EmailItem) => email.id === id)?.value || '';
    }
        
    return '';
  };
    
  const getPhoneError = (id: string) => {
    if (formErrors?.phones) {
      return formErrors?.phones.find((phone:PhoneItem) => phone.id === id)?.value || '';
    }
        
    return '';
  };

  const getContactDetails = () => {
    return (
      <>
        { arrEmails  && arrEmails.map((item:EmailItem) => {
          const emailError: string = getMailError(item.id);

          return (
            <Fragment key={ item.id }>
              <BasicEmailRow
                error={ emailError }
                onValueChange={ (e:React.ChangeEvent<HTMLInputElement>) => {
                  if (editEmailArrayHandler) {
                    editEmailArrayHandler({
                      id: item.id,
                      value: e?.target.value,
                    });
                  }
                } }
                value={ item.value }
                label={ translate(STRING_KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_EMAIL) }
                onDeleteEmail={ () => handleDeleteEmailRow && handleDeleteEmailRow(item.id) }
                isShowDeleteButton={ !disabled }
                placeholder={ translate(STRING_KEYS.PLACEHOLDER_ENTER_EMAIL) }
              />
              { emailError ? <ErrorMessage message={ emailError } /> : <Divider /> }
            </Fragment>
          );
        }) }

        { arrPhones && arrPhones.map((item:PhoneItem) => {
          const phoneError:string = getPhoneError(item.id);

          return (
            <Fragment key={ item.id }>
              <BasicPhoneRow
                error={ phoneError }
                onValueChange={ (e: React.ChangeEvent<HTMLInputElement>) => {
                  if (editPhoneArrayHandler) {
                    editPhoneArrayHandler({
                      id: item.id,
                      value: e?.target.value,
                    });
                  }
                } }
                value={ item.value }
                label={ translate(STRING_KEYS.TALENTS_EDIT_BASIC_DETAILS_INPUTS_LABEL_PHONE) }
                onDeletePhone={ () => {
                  if (handleDeletePhoneRow) {
                    handleDeletePhoneRow(item.id);
                  }
                } }
                placeholder={ translate(STRING_KEYS.PLACEHOLDER_ENTER_PHONE) }
                isShowDeleteButton={ !disabled }
              />
              { phoneError ? <ErrorMessage message={ phoneError } /> : <Divider /> }
            </Fragment>
          );
        }) }
      </>
    );
  };

  return getContactDetails();
}
